import { debounce } from 'lodash';

import REBSCarousel from './components/rebs-carousel';
import PropertyListFilterForm from './components/property-list-filter-form';
import SearchEngine from './components/search-engine';

function initializeFilterLogic() {
  let $filterForm = $('#property-list-filter-form');
  if ($filterForm.length > 0) {
    new PropertyListFilterForm($filterForm);
  }
}

function initializeCarousels() {
  $('.row-property-list .rebs-carousel').each(function(index, el) {
    let $el = $(el),
        c = new REBSCarousel(el, {
          enableFullscreen: false
        });
  });
}

$(function () {
  initializeFilterLogic();
  initializeCarousels();
});
